import { render } from "./MobileAsideHeader.vue?vue&type=template&id=20f57079&ts=true"
import script from "./MobileAsideHeader.vue?vue&type=script&lang=ts"
export * from "./MobileAsideHeader.vue?vue&type=script&lang=ts"

import "./MobileAsideHeader.vue?vue&type=style&index=0&id=20f57079&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__